@if (type === 'col') {
<section class="body-feedback w-full relative">
  <div class="body-feedback-nothing-filled-paper flex flex-row w-full justify-center">
    <div class="flex">
      <span class="body-feedback-nothing-filled w-[129px] h-[133px] block"></span>
    </div>
    <div class="body-feedback-nothing-filled-text-container flex flex-col justify-center ml-[40px]">
      <div class="body-feedback-nothing-filled-tit tracking-[1px] text-2xl">
        <ng-content select="[colMessagePrimary]"></ng-content>
      </div>
      <div class="body-feedback-nothing-filled-subtit text-xs text-gray-600">
        <ng-content select="[colMessageSecondary]"></ng-content>
      </div>
    </div>
  </div>
</section>
} @if (type === 'row') {
<section class="body-feedback h-[352px]">
  @if (feedback === 'notfound') {
  <div class="body-row-feedback-div">
    <ng-template [ngTemplateOutlet]="notfound"></ng-template>
  </div>
  } @if (feedback === 'searching') {
  <div class="body-row-feedback-div">
    <div class="w-280 relative">
      <ng-template [ngTemplateOutlet]="pesquisando"></ng-template>
      <ng-template [ngTemplateOutlet]="pesquisandolupa"></ng-template>
    </div>
  </div>
  } @if (feedback === 'caixavazia') {
  <div class="body-row-feedback-div">
    <ng-template [ngTemplateOutlet]="caixaVazia"></ng-template>
  </div>
  }
  <div
    class="body-row-feedback-div body-feedback-tit text-gray-600 mt-[20px] tracking-[1px] text-2xl"
  >
    <ng-content select="[rowMessagePrimary]"></ng-content>
  </div>
  <div class="body-row-feedback-div body-feedback-sub text-[13px] mt-[15px] text-gray-700">
    <ng-content select="[rowMessageSecondary]"></ng-content>
  </div>
</section>
} @if (type === 'claim') {
<section class="body-feedback h-[352px]">
  @if (feedback === 'noLegalrequests') {
  <div class="body-row-feedback-div flex items-center justify-center w-full">
    <ng-template [ngTemplateOutlet]="noLegalrequests"></ng-template>
  </div>
  }
  <div
    class="body-row-feedback-div body-feedback-tit-legal flex items-center justify-center w-full text-gray-600 mt-[20px] tracking-[1px] text-base"
  >
    <ng-content select="[claimMessagePrimary]"></ng-content>
  </div>
  <div
    class="body-row-feedback-div body-feedback-sub flex items-center justify-center w-full text-[13px] mt-[15px] text-gray-700"
  >
    <ng-content select="[claimMessageSecondary]"></ng-content>
  </div>
</section>
} @if (type === 'files') {
<section class="body-feedback h-[352px] mt-[40px]">
  @if (feedback === 'noFiles') {
  <div class="body-row-feedback-div flex items-center justify-center w-full">
    <ng-template [ngTemplateOutlet]="noFiles"></ng-template>
  </div>
  }
  <div
    class="body-row-feedback-div body-feedback-tit-legal text-center flex items-center justify-center w-full text-gray-600 mt-[20px] tracking-[1px] text-base"
  >
    <ng-content select="[filesMessagePrimary]"></ng-content>
  </div>
  <div
    class="body-row-feedback-div body-feedback-sub flex items-center justify-center w-full text-[13px] mt-[15px] text-gray-700"
  >
    <ng-content select="[filesMessageSecondary]"></ng-content>
  </div>
</section>
} @if (type === 'table-list') {
<section class="body-feedback h-[352px] mt-[40px]">
  <div class="body-row-feedback-div flex items-center justify-center w-full">
    <ng-template [ngTemplateOutlet]="pesquisando"></ng-template>
  </div>
  <div
    class="body-row-feedback-div body-feedback-tit-legal text-center flex items-center justify-center w-full text-gray-600 mt-[20px] tracking-[1px] text-base"
  >
    <ng-content select="[tableMessagePrimary]"></ng-content>
  </div>
</section>
} @if (type === 'panel') {
<section class="body-search w-full mt-[20px] z-[1000] relative">
  <div class="body-row-search-div flex items-center justify-center w-full">
    <span class="body-search-firstOpen mt-[10px] w-[314px] h-[180px] block bg-gray-200"></span>
  </div>
</section>
}

<ng-template #pesquisando>
  <svg
    width="279"
    height="253"
    viewBox="0 0 279 253"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="37.3098"
      cy="4.30952"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="4.30977"
      cy="4.30952"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="70.3491"
      cy="4.30952"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="103.389"
      cy="4.30952"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="136.428"
      cy="4.30952"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="169.468"
      cy="4.30952"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="202.508"
      cy="4.30952"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="37.3095"
      cy="33.0395"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="4.30952"
      cy="33.0395"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="70.3492"
      cy="33.0395"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="103.389"
      cy="33.0395"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="136.429"
      cy="33.0395"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="169.468"
      cy="33.0395"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="202.508"
      cy="91.3095"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="202.508"
      cy="33.0395"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="37.3095"
      cy="61.77"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="4.30952"
      cy="61.77"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="70.3492"
      cy="61.77"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="103.389"
      cy="61.77"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="37.3095"
      cy="90.5"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="4.30952"
      cy="90.5"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="70.3492"
      cy="90.5"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="136.429"
      cy="90.5"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="169.468"
      cy="90.5"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="37.3095"
      cy="119.23"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="4.30952"
      cy="119.23"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="103.389"
      cy="119.23"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="136.429"
      cy="119.23"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="169.468"
      cy="119.23"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="202.508"
      cy="119.23"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="235.548"
      cy="119.23"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="37.3095"
      cy="147.96"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="4.30952"
      cy="147.96"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="70.3492"
      cy="147.96"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="103.389"
      cy="147.96"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="136.429"
      cy="147.96"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="169.468"
      cy="147.96"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="202.508"
      cy="147.96"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="235.548"
      cy="147.96"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="37.3095"
      cy="176.691"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="4.30952"
      cy="176.691"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="70.3492"
      cy="176.69"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="103.389"
      cy="176.69"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="136.429"
      cy="176.69"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="202.508"
      cy="176.69"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <path
      d="M110.5 89L143 84L193 208.5L134 219.5L110.5 89Z"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <path
      d="M81.5 110.5L114 99L180.5 213L127.5 237.5L107 184L99.5 163L81.5 110.5Z"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <path
      d="M146.5 68H226.786L249.5 90.5795V207C249.5 208.657 248.157 210 246.5 210H146.5C144.843 210 143.5 208.657 143.5 207V101.117V81.0459V71C143.5 69.3431 144.843 68 146.5 68Z"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <path
      d="M138.5 75.0459V65C138.5 63.3431 139.843 62 141.5 62H221.786L244.5 84.5795V201C244.5 202.657 243.157 204 241.5 204H141.5C139.843 204 138.5 202.657 138.5 201V95.1166M138.5 80.0636V89.0954"
      class="stroke-gray-800"
    />
    <rect x="171" y="95.5" width="56" height="6" rx="1.5" class="stroke-gray-800" />
    <rect x="156" y="95.5" width="8" height="6" rx="1.5" class="stroke-gray-800" />
    <rect x="171" y="118.5" width="56" height="6" rx="1.5" class="stroke-gray-800" />
    <rect x="156" y="118.5" width="8" height="6" rx="1.5" class="stroke-gray-800" />
    <rect x="171" y="141.5" width="56" height="6" rx="1.5" class="stroke-gray-800" />
    <rect x="156" y="141.5" width="8" height="6" rx="1.5" class="stroke-gray-800" />
    <rect x="171" y="164.5" width="56" height="6" rx="1.5" class="stroke-gray-800" />
    <rect x="156" y="164.5" width="8" height="6" rx="1.5" class="stroke-gray-800" />
    <path
      d="M221.65 80.8573L222.5 63L244 84H224.646C222.933 84 221.568 82.5682 221.65 80.8573Z"
      class="stroke-gray-800"
    />
    <path d="M138.5 80L106 85L129.5 215.5L191 204" class="stroke-gray-800" />
    <path
      d="M107.5 97L75 108.5L80.8286 125.5M179 206L121 235.5L100.5 182L93 161L87.5 145M82.5 131L85.5 139"
      class="stroke-gray-800"
    />
    <path d="M237 214L208.034 214M201 214L189 214" class="stroke-gray-800" />
  </svg>
</ng-template>

<ng-template #pesquisandolupa>
  <svg
    width="69"
    height="63"
    viewBox="0 0 69 63"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="pesquisando"
  >
    <circle
      cx="27"
      cy="26"
      r="21"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-200]="place === 'module'"
    />
    <path
      d="M63.0573 55.2802L48.8632 41.0867C47.6085 39.8321 45.5742 39.8323 44.3198 41.0872C43.0657 42.3418 43.0659 44.3754 44.3202 45.6298L58.5141 59.8236C59.7687 61.0782 61.8028 61.0782 63.0574 59.8236C64.312 58.569 64.312 56.5348 63.0573 55.2802Z"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M25.876 51.7519C40.1668 51.7519 51.7519 40.1668 51.7519 25.876C51.7519 11.5851 40.1668 0 25.876 0C11.5851 0 0 11.5851 0 25.876C0 40.1668 11.5851 51.7519 25.876 51.7519ZM25.876 45.2829C36.5941 45.2829 45.2829 36.5941 45.2829 25.876C45.2829 15.1578 36.5941 6.46899 25.876 6.46899C15.1578 6.46899 6.46899 15.1578 6.46899 25.876C6.46899 36.5941 15.1578 45.2829 25.876 45.2829Z"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle cx="29.1104" cy="25.876" r="25.376" class="stroke-gray-800" />
    <path
      d="M41.5864 11.0097C38.213 8.17567 33.861 6.46875 29.1105 6.46875C18.3923 6.46875 9.70349 15.1575 9.70349 25.8757C9.70349 36.5939 18.3923 45.2827 29.1105 45.2827C39.1118 45.2827 47.3462 37.7172 48.4028 27.9969C48.4786 27.3002 48.5174 26.5925 48.5174 25.8757C48.5174 24.7737 48.4256 23.6931 48.2491 22.6412M46.1643 16.6053C46.6511 17.4989 47.0697 18.4351 47.4131 19.4067"
      class="stroke-gray-800"
    />
    <path
      d="M50.1347 39.0911L66.7128 55.6685C67.976 56.9316 67.976 58.9796 66.7129 60.2428V60.2428C65.4497 61.5059 63.4018 61.5059 62.1387 60.2428L45.5617 43.6658"
      class="stroke-gray-800"
    />
  </svg>
</ng-template>

<ng-template #notfound>
  <svg
    width="279"
    height="253"
    viewBox="0 0 279 253"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="37.3098"
      cy="4.30977"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="4.30977"
      cy="4.30977"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="70.3491"
      cy="4.30952"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="103.389"
      cy="4.30952"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="136.428"
      cy="4.30952"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="169.468"
      cy="4.30952"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="202.508"
      cy="4.30952"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="37.3095"
      cy="33.0397"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="4.30952"
      cy="33.0397"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="70.3492"
      cy="33.0397"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="103.389"
      cy="33.0397"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="136.429"
      cy="33.0397"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="169.468"
      cy="33.0397"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="202.508"
      cy="91.3095"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="202.508"
      cy="33.0397"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="37.3095"
      cy="61.77"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="4.30952"
      cy="61.77"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="70.3492"
      cy="61.7697"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="103.389"
      cy="61.7697"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="37.3095"
      cy="90.5002"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="4.30952"
      cy="90.5002"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="70.3492"
      cy="90.5002"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="136.429"
      cy="90.5002"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="169.468"
      cy="90.5002"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="37.3095"
      cy="119.23"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="4.30952"
      cy="119.23"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="103.389"
      cy="119.23"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="136.429"
      cy="119.23"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="169.468"
      cy="119.23"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="202.508"
      cy="119.23"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="235.548"
      cy="119.23"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="37.3095"
      cy="147.96"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="4.30952"
      cy="147.96"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="70.3492"
      cy="147.96"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="103.389"
      cy="147.96"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="136.429"
      cy="147.96"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="169.468"
      cy="147.96"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="202.508"
      cy="147.96"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="235.548"
      cy="147.96"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="37.3095"
      cy="176.691"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="4.30952"
      cy="176.691"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="70.3492"
      cy="176.69"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="103.389"
      cy="176.69"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="136.429"
      cy="176.69"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="202.508"
      cy="176.69"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <path
      d="M110.5 89L143 84L193 208.5L134 219.5L110.5 89Z"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <path
      d="M81.5 110.5L114 99L180.5 213L127.5 237.5L107 184L99.5 163L81.5 110.5Z"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <path
      d="M146.5 68H226.786L249.5 90.5795V207C249.5 208.657 248.157 210 246.5 210H146.5C144.843 210 143.5 208.657 143.5 207V101.117V81.0459V71C143.5 69.3431 144.843 68 146.5 68Z"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <path
      d="M138.5 75.0459V65C138.5 63.3431 139.843 62 141.5 62H221.786L244.5 84.5795V201C244.5 202.657 243.157 204 241.5 204H141.5C139.843 204 138.5 202.657 138.5 201V95.1166M138.5 80.0636V89.0954"
      class="stroke-gray-800"
    />
    <rect x="171" y="95.5" width="56" height="6" rx="1.5" class="stroke-gray-800" />
    <rect x="156" y="95.5" width="8" height="6" rx="1.5" class="stroke-gray-800" />
    <rect x="171" y="118.5" width="56" height="6" rx="1.5" class="stroke-gray-800" />
    <rect x="156" y="118.5" width="8" height="6" rx="1.5" class="stroke-gray-800" />
    <rect x="171" y="141.5" width="56" height="6" rx="1.5" class="stroke-gray-800" />
    <rect x="156" y="141.5" width="8" height="6" rx="1.5" class="stroke-gray-800" />
    <rect x="171" y="164.5" width="56" height="6" rx="1.5" class="stroke-gray-800" />
    <rect x="156" y="164.5" width="8" height="6" rx="1.5" class="stroke-gray-800" />
    <path
      d="M221.65 80.8573L222.5 63L244 84H224.646C222.933 84 221.568 82.5682 221.65 80.8573Z"
      class="stroke-gray-800"
    />
    <path d="M138.5 80L106 85L129.5 215.5L191 204" class="stroke-gray-800" />
    <path
      d="M107.5 97L75 108.5L80.8286 125.5M179 206L121 235.5L100.5 182L93 161L87.5 145M82.5 131L85.5 139"
      class="stroke-gray-800"
    />
    <path d="M237 214L208.034 214M201 214L189 214" class="stroke-gray-800" />
    <ellipse
      cx="238.5"
      cy="191"
      rx="26.5"
      ry="27"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle cx="241.5" cy="192.5" r="26" class="stroke-gray-800" />
    <path
      opacity="0.5"
      d="M249.293 177.707L242 185L234.707 177.707C234.317 177.317 233.683 177.317 233.293 177.707L226.707 184.293C226.317 184.683 226.317 185.317 226.707 185.707L234 193L226.707 200.293C226.317 200.683 226.317 201.317 226.707 201.707L233.293 208.293C233.683 208.683 234.317 208.683 234.707 208.293L242 201L249.293 208.293C249.683 208.683 250.317 208.683 250.707 208.293L257.293 201.707C257.683 201.317 257.683 200.683 257.293 200.293L250 193L257.293 185.707C257.683 185.317 257.683 184.683 257.293 184.293L250.707 177.707C250.317 177.317 249.683 177.317 249.293 177.707Z"
      class="fill-12"
    />
    <path
      d="M248.293 175.707L241 183L233.707 175.707C233.317 175.317 232.683 175.317 232.293 175.707L225.707 182.293C225.317 182.683 225.317 183.317 225.707 183.707L233 191L225.707 198.293C225.317 198.683 225.317 199.317 225.707 199.707L232.293 206.293C232.683 206.683 233.317 206.683 233.707 206.293L241 199L248.293 206.293C248.683 206.683 249.317 206.683 249.707 206.293L256.293 199.707C256.683 199.317 256.683 198.683 256.293 198.293L249 191L256.293 183.707C256.683 183.317 256.683 182.683 256.293 182.293L249.707 175.707C249.317 175.317 248.683 175.317 248.293 175.707Z"
      class="stroke-gray-800"
    />
  </svg>
</ng-template>

<ng-template #caixaVazia>
  <svg
    width="279"
    height="219"
    viewBox="0 0 279 219"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="109.31"
      cy="4.30965"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="76.3098"
      cy="4.30965"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="142.349"
      cy="4.30952"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="175.389"
      cy="4.30952"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="208.428"
      cy="4.30952"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="241.468"
      cy="4.30952"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="274.508"
      cy="4.30952"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="109.31"
      cy="33.0397"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="76.3095"
      cy="33.0397"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="142.349"
      cy="33.0397"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="175.389"
      cy="33.0397"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="208.429"
      cy="33.0397"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="208.429"
      cy="61.3095"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="241.468"
      cy="33.0397"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="241.468"
      cy="61.3095"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="274.508"
      cy="91.3095"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="274.508"
      cy="33.0397"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="274.508"
      cy="61.3095"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="109.31"
      cy="61.7699"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="76.3095"
      cy="61.7699"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="142.349"
      cy="61.7697"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="175.389"
      cy="61.7697"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="109.31"
      cy="90.5001"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="76.3095"
      cy="90.5001"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="142.349"
      cy="90.5001"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="208.429"
      cy="90.5001"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="175.31"
      cy="90.5001"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="241.468"
      cy="90.5001"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="109.31"
      cy="119.23"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="76.3095"
      cy="119.23"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="175.389"
      cy="119.23"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="208.429"
      cy="119.23"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="175.31"
      cy="119.23"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="241.468"
      cy="119.23"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="274.508"
      cy="119.23"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="109.31"
      cy="147.96"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="76.3095"
      cy="147.96"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="142.349"
      cy="147.96"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="175.389"
      cy="147.96"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="208.429"
      cy="147.96"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="175.31"
      cy="147.96"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="241.468"
      cy="147.96"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="274.508"
      cy="147.96"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="109.31"
      cy="176.691"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="76.3095"
      cy="176.691"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="142.349"
      cy="176.69"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="175.389"
      cy="176.69"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="208.429"
      cy="176.69"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="274.508"
      cy="176.69"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <circle
      cx="241.31"
      cy="176.69"
      r="4.30952"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <path d="M67 218.5V192H94.5V218.5H67Z" class="fill-4" />
    <path
      d="M67 218.5V192H94.5L81 205L67 218.5Z"
      [class.fill-gray-200]="place === 'body'"
      [class.fill-gray-50]="place === 'module'"
    />
    <path
      d="M14.3511 130C17.5511 107.6 34.3511 101 42.3511 100.5H164.851V184H212.851V192.5H14.3511V130Z"
      class="fill-4"
    />
    <path
      d="M128.851 125V183.5H189.351V122C187.851 114.5 179.551 99.7 158.351 100.5C137.151 101.3 129.851 117.167 128.851 125Z"
      fill="#D1E0FF"
    />
    <path d="M129 180V126L177 180H129Z" fill="#BCCDEF" />
    <path d="M195 199L166.034 199M159 199L147 199" class="stroke-gray-800" />
    <path d="M1 183L0.999999 154.034M0.999998 147L0.999998 135" class="stroke-gray-800" />
    <circle cx="52.8511" cy="123" r="10" fill="#D1E0FF" />
    <path
      d="M50.3511 122.75V71H66.1011C70.9336 71 74.8511 74.9175 74.8511 79.75C74.8511 84.5825 70.9336 88.5 66.1011 88.5H54.8511V122.75C54.8511 123.993 53.8437 125 52.6011 125C51.3584 125 50.3511 123.993 50.3511 122.75Z"
      class="fill-1"
    />
    <path d="M185 180H208.5V188.5H10V126C13.2 103.6 30 97 38 96.5H153.5" class="stroke-gray-800" />
    <path
      d="M48 118.75V67H63.75C68.5825 67 72.5 70.9175 72.5 75.75C72.5 80.5825 68.5825 84.5 63.75 84.5H52.5V118.75C52.5 119.993 51.4926 121 50.25 121C49.0074 121 48 119.993 48 118.75Z"
      class="stroke-gray-800"
    />
    <path
      d="M124.5 121V179.5H185V118C183.5 110.5 175.2 95.7 154 96.5C132.8 97.3 125.5 113.167 124.5 121Z"
      class="stroke-gray-800"
    />
    <path d="M63 215V188.5H91V215" class="stroke-gray-800" />
  </svg>
</ng-template>

<ng-template #noLegalrequests>
  <svg
    width="200"
    height="220"
    viewBox="0 0 173 155"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="22.7203" cy="2.62436" r="2.62436" class="fill-3" />
    <circle cx="2.62436" cy="2.62436" r="2.62436" class="fill-3" />
    <circle cx="42.8399" cy="2.62436" r="2.62436" class="fill-3" />
    <circle cx="62.9603" cy="2.62436" r="2.62436" class="fill-3" />
    <circle cx="83.0804" cy="2.62436" r="2.62436" class="fill-3" />
    <circle cx="103.2" cy="2.62436" r="2.62436" class="fill-3" />
    <circle cx="123.32" cy="2.62436" r="2.62436" class="fill-3" />
    <circle cx="22.7203" cy="20.1204" r="2.62436" class="fill-3" />
    <circle cx="2.62436" cy="20.1204" r="2.62436" class="fill-3" />
    <circle cx="42.8404" cy="20.1204" r="2.62436" class="fill-3" />
    <circle cx="62.9603" cy="20.1204" r="2.62436" class="fill-3" />
    <circle cx="83.0804" cy="20.1204" r="2.62436" class="fill-3" />
    <circle cx="103.2" cy="20.1204" r="2.62436" class="fill-3" />
    <circle cx="123.32" cy="55.6043" r="2.62436" class="fill-3" />
    <circle cx="123.32" cy="20.1204" r="2.62436" class="fill-3" />
    <circle cx="22.7203" cy="37.6161" r="2.62436" class="fill-3" />
    <circle cx="2.62436" cy="37.6161" r="2.62436" class="fill-3" />
    <circle cx="42.8404" cy="37.6161" r="2.62436" class="fill-3" />
    <circle cx="62.9603" cy="37.6161" r="2.62436" class="fill-3" />
    <circle cx="22.7203" cy="55.1121" r="2.62436" class="fill-3" />
    <circle cx="2.62436" cy="55.1121" r="2.62436" class="fill-3" />
    <circle cx="42.8404" cy="55.1121" r="2.62436" class="fill-3" />
    <circle cx="83.0804" cy="55.1121" r="2.62436" class="fill-3" />
    <circle cx="103.2" cy="55.1121" r="2.62436" class="fill-3" />
    <circle cx="22.7203" cy="72.6068" r="2.62436" class="fill-3" />
    <circle cx="2.62436" cy="72.6068" r="2.62436" class="fill-3" />
    <circle cx="62.9603" cy="72.6068" r="2.62436" class="fill-3" />
    <circle cx="83.0804" cy="72.6068" r="2.62436" class="fill-3" />
    <circle cx="103.2" cy="72.6068" r="2.62436" class="fill-3" />
    <circle cx="123.32" cy="72.6068" r="2.62436" class="fill-3" />
    <circle cx="143.441" cy="72.6068" r="2.62436" class="fill-3" />
    <circle cx="22.7203" cy="90.1029" r="2.62436" class="fill-3" />
    <circle cx="2.62436" cy="90.1029" r="2.62436" class="fill-3" />
    <circle cx="42.8404" cy="90.1029" r="2.62436" class="fill-3" />
    <circle cx="62.9603" cy="90.1029" r="2.62436" class="fill-3" />
    <circle cx="83.0804" cy="90.1029" r="2.62436" class="fill-3" />
    <circle cx="103.2" cy="90.1029" r="2.62436" class="fill-3" />
    <circle cx="123.32" cy="90.1029" r="2.62436" class="fill-3" />
    <circle cx="143.441" cy="90.1029" r="2.62436" class="fill-3" />
    <circle cx="22.7203" cy="107.598" r="2.62436" class="fill-3" />
    <circle cx="2.62436" cy="107.598" r="2.62436" class="fill-3" />
    <circle cx="42.8404" cy="107.598" r="2.62436" class="fill-3" />
    <circle cx="62.9603" cy="107.598" r="2.62436" class="fill-3" />
    <circle cx="83.0804" cy="107.598" r="2.62436" class="fill-3" />
    <circle cx="123.32" cy="107.598" r="2.62436" class="fill-3" />
    <path
      d="M67.2908 54.1982L87.0822 51.1533L117.531 126.97L81.6015 133.668L67.2908 54.1982Z"
      class="fill-3"
    />
    <path
      d="M49.6309 67.2907L69.4223 60.2876L109.919 129.71L77.6433 144.629L65.1595 112.05L60.5923 99.2615L49.6309 67.2907Z"
      class="fill-3"
    />
    <path
      d="M90.3867 41.4097H138.105L151.937 55.1598V124.883C151.937 126.54 150.594 127.883 148.937 127.883H90.3867C88.7299 127.883 87.3867 126.54 87.3867 124.883V61.5766V49.3542V44.4097C87.3867 42.7528 88.7299 41.4097 90.3867 41.4097Z"
      class="fill-3"
    />
    <path
      d="M84.3418 45.7004V40.7559C84.3418 39.099 85.6849 37.7559 87.3418 37.7559H135.06L148.892 51.506V121.229C148.892 122.886 147.549 124.229 145.892 124.229H87.3418C85.6849 124.229 84.3418 122.886 84.3418 121.229V57.9228M84.3418 48.756V54.2561"
      class="stroke-gray-600"
    />
    <rect
      x="96.1077"
      y="58.9609"
      width="33.7111"
      height="3.26277"
      rx="1.5"
      class="stroke-gray-600"
    />
    <rect
      x="96.1077"
      y="82.7104"
      width="33.7111"
      height="3.26277"
      rx="1.5"
      class="stroke-gray-600"
    />
    <rect
      x="96.1077"
      y="74.1851"
      width="44.0635"
      height="3.26277"
      rx="1.5"
      class="stroke-gray-600"
    />
    <rect
      x="96.1077"
      y="66.2686"
      width="23.9676"
      height="3.26277"
      rx="1.5"
      class="stroke-gray-600"
    />
    <rect
      x="96.1077"
      y="90.0181"
      width="23.9676"
      height="3.26277"
      rx="1.5"
      class="stroke-gray-600"
    />
    <rect
      x="124.12"
      y="66.2686"
      width="16.0511"
      height="3.26277"
      rx="1.5"
      class="stroke-gray-600"
    />
    <rect
      x="124.12"
      y="90.0181"
      width="16.0511"
      height="3.26277"
      rx="1.5"
      class="stroke-gray-600"
    />
    <rect
      x="134.473"
      y="58.9609"
      width="5.69863"
      height="3.26277"
      rx="1.5"
      class="stroke-gray-600"
    />
    <rect
      x="134.473"
      y="82.7104"
      width="5.69863"
      height="3.26277"
      rx="1.5"
      class="stroke-gray-600"
    />
    <path
      d="M135.036 48.0104L135.495 38.3647L148.588 51.153H138.032C136.32 51.153 134.954 49.7213 135.036 48.0104Z"
      class="stroke-gray-600"
    />
    <path
      d="M84.342 48.7173L64.5505 51.7621L78.8613 131.232L116.313 124.229"
      class="stroke-gray-600"
    />
    <path
      d="M65.464 59.0698L45.6726 66.0729L49.222 76.4254M109.005 125.447L73.6851 143.412L61.2013 110.832L56.634 98.0437L53.2847 88.3002M50.2399 79.7747L52.0668 84.6464"
      class="stroke-gray-600"
    />
    <path
      d="M128.416 140.398C124.031 91.1931 155.413 90.6653 171.652 96.552C167.755 105.808 154.804 120.911 148.816 127.305L139.986 123.956L143.944 130.046L128.416 140.398Z"
      class="fill-3"
    />
    <path
      d="M128.416 140.398C124.031 91.1931 155.413 90.6653 171.652 96.552C167.755 105.808 154.804 120.911 148.816 127.305L139.986 123.956L143.944 130.046L128.416 140.398ZM128.416 140.398V151.968"
      class="stroke-gray-600"
    />
    <path
      d="M129.025 140.094C129.144 133.822 131.085 123.33 136.784 114.517M154.906 100.511C151.311 101.594 148.182 103.207 145.467 105.186M145.467 105.186L148.816 98.3799M145.467 105.186H157.646M145.467 105.186C141.9 107.786 139.046 111.02 136.784 114.517M136.784 114.517H150.338M136.784 114.517L138.768 105.186"
      class="stroke-gray-600"
    />
  </svg>
</ng-template>

<ng-template #noFiles>
  <svg
    width="258"
    height="237"
    viewBox="0 0 258 237"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M177 111H212M220.5 111H235" class="stroke-gray-900" />
    <path d="M97 236H132M140.5 236H155" class="stroke-gray-900" />
    <circle cx="4.30983" cy="4.30952" r="4.30952" class="fill-4" />
    <circle cx="37.349" cy="4.30952" r="4.30952" class="fill-4" />
    <circle cx="70.3887" cy="4.30952" r="4.30952" class="fill-4" />
    <circle cx="103.428" cy="4.30952" r="4.30952" class="fill-4" />
    <circle cx="136.468" cy="4.30952" r="4.30952" class="fill-4" />
    <circle cx="169.508" cy="4.30952" r="4.30952" class="fill-4" />
    <circle cx="4.30952" cy="33.04" r="4.30952" class="fill-4" />
    <circle cx="37.3492" cy="33.04" r="4.30952" class="fill-4" />
    <circle cx="70.3889" cy="33.04" r="4.30952" class="fill-4" />
    <circle cx="103.429" cy="33.04" r="4.30952" class="fill-4" />
    <circle cx="136.468" cy="33.04" r="4.30952" class="fill-4" />
    <circle cx="136.468" cy="61.7705" r="4.30952" class="fill-4" />
    <circle cx="169.508" cy="61.7705" r="4.30952" class="fill-4" />
    <circle cx="169.508" cy="91.3095" r="4.30952" class="fill-4" />
    <circle cx="169.508" cy="33.04" r="4.30952" class="fill-4" />
    <circle cx="4.30952" cy="61.7695" r="4.30952" class="fill-4" />
    <circle cx="37.3492" cy="61.7695" r="4.30952" class="fill-4" />
    <circle cx="70.3889" cy="61.7695" r="4.30952" class="fill-4" />
    <circle cx="103.429" cy="61.7695" r="4.30952" class="fill-4" />
    <circle cx="4.30952" cy="90.5" r="4.30952" class="fill-4" />
    <circle cx="37.3492" cy="90.5" r="4.30952" class="fill-4" />
    <circle cx="70.3889" cy="90.5" r="4.30952" class="fill-4" />
    <circle cx="103.429" cy="90.5" r="4.30952" class="fill-4" />
    <circle cx="136.468" cy="90.5" r="4.30952" class="fill-4" />
    <circle cx="4.30952" cy="119.23" r="4.30952" class="fill-4" />
    <circle cx="37.3492" cy="119.23" r="4.30952" class="fill-4" />
    <circle cx="70.3889" cy="119.23" r="4.30952" class="fill-4" />
    <circle cx="103.429" cy="119.23" r="4.30952" class="fill-4" />
    <circle cx="136.468" cy="119.23" r="4.30952" class="fill-4" />
    <circle cx="169.508" cy="119.23" r="4.30952" class="fill-4" />
    <circle cx="202.548" cy="119.23" r="4.30952" class="fill-4" />
    <circle cx="4.30952" cy="147.96" r="4.30952" class="fill-4" />
    <circle cx="37.3492" cy="147.96" r="4.30952" class="fill-4" />
    <circle cx="70.3889" cy="147.96" r="4.30952" class="fill-4" />
    <circle cx="103.429" cy="147.96" r="4.30952" class="fill-4" />
    <circle cx="136.468" cy="147.96" r="4.30952" class="fill-4" />
    <circle cx="169.508" cy="147.96" r="4.30952" class="fill-4" />
    <circle cx="202.548" cy="147.96" r="4.30952" class="fill-4" />
    <circle cx="4.30952" cy="176.69" r="4.30952" class="fill-4" />
    <circle cx="37.3492" cy="176.69" r="4.30952" class="fill-4" />
    <circle cx="70.3889" cy="176.69" r="4.30952" class="fill-4" />
    <circle cx="103.429" cy="176.69" r="4.30952" class="fill-4" />
    <circle cx="169.508" cy="176.69" r="4.30952" class="fill-4" />
    <path
      d="M96.0752 112.48V220H239V125.569C239 118.837 232.991 117.778 229.987 118.089H161.743C157.88 118.089 154.018 118.463 154.018 112.48C154.018 106.496 149.726 105 147.58 105H105.089C96.8478 105 95.646 109.986 96.0752 112.48Z"
      class="fill-6"
    />
    <path
      d="M106.572 148.829L96 220H238.717C243.003 196.276 251.831 146.68 252.86 138.086C253.888 129.491 249.003 126.448 246.431 126H192.43C186.002 126 184.716 132.714 183.43 138.086C182.401 142.383 181.287 143.457 179.573 143.457H114.286C109.143 143.457 107 147.038 106.572 148.829Z"
      class="fill-3"
    />
    <path
      d="M110.572 153.829L100 225H242.717C247.003 201.276 255.831 151.68 256.86 143.086C257.888 134.491 253.003 131.448 250.431 131H196.43C190.002 131 188.716 137.714 187.43 143.086C186.401 147.383 185.287 148.457 183.573 148.457H118.286C113.143 148.457 111 152.038 110.572 153.829Z"
      class="stroke-gray-900"
    />
  </svg>
</ng-template>
